<template>
  <div>
    <div class="sld_diy" :style="'background-color:' + background">
      <div v-for="(item, index) in decorateData.data" v-bind:key="index">
        <div v-if="item.json_data && item.json_data.type === 'main_banner'&& !isTopic">
          <el-carousel
            v-if="bannerVisSet && bannerDatasSet"
            height="500px"
            arrow="hover"
            :interval = "4000"
            style="margin-bottom: 40px;max-width: 1920px;"
          >
          <div v-for="(item_banner, index_banner) in banner" :key="index_banner">
          <!-- 登录 -->
            <el-carousel-item
              
              v-if="loginFlag && bannerVisibility.get(index_banner)"
            >
              <a href="javascript:void(0)" @click="dragEvent(item_banner),diyNavTo(item_banner.datas)">
                <div
                  :style="`background-image:url(${item_banner.datas.imgUrl})`"
                ></div>
                <!-- <div style="background-image: url('../assets/forget_pwd_bg.png');"></div> -->
              </a>
            </el-carousel-item>

            <!-- 未登录 -->
            <el-carousel-item

              v-if="!loginFlag"
            >
              <a href="javascript:void(0)" @click="dragEvent(item_banner),diyNavTo(item_banner.datas)">
                <div
                  :style="`background-image:url(${item_banner.datas.imgUrl})`"
                ></div>
                <!-- <div style="background-image: url('../assets/forget_pwd_bg.png');"></div> -->
              </a>
            </el-carousel-item>
          </div>
            
          </el-carousel>

          <div v-else style="height:540px;">

          </div>
        </div>
        

        <!-- 热区切图start -->
         <!-- 登录 -->
        <div
          class="hot_wrap"
          v-if="item.json_data && item.json_data.type === 'pic_hot' && hotPicVisibility.get(index) && loginFlag"
          :style="{
            height: (item.json_data.data.wSet === 'noset' ? (winWidth -17) : 1336)
               * (item.json_data.data.height / item.json_data.data.width) +
              'px',
            width: item.json_data.data.wSet === 'noset' ? '100%' : '1336px',
            margin: 'auto',
            marginBottom:hotPicVisibility.get(index)? '40px':'0px',
            paddingTop: item.json_data.padding_top + 'px',
            // paddingBottom: item.json_data.padding_bottom === '0' || item.json_data.padding_bottom === 0 ? '0px' : '40px',
            // paddingBottom:isShowHotPic? '40px':'0px',
            backgroundImage: 'url(' + item.json_data.data.img + ')',
            backgroundSize:
              item.json_data.data.wSet === 'noset' ? 'cover' : 'contain',
            backgroundPosition:
              item.json_data.data.wSet === 'noset' ? 'center' : 'center',
          }"
        >
          <div
            class="hot_area_div"
            v-for="(i, index1) in item.json_data.data.items"
            @click="diyNavTo(i)"
            :key="index1"
            :style="{
              top: (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) * (i.y / 710) + 'px',
              left: (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) * (i.x / 710) + 'px',
              width: (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) * (i.width / 710) + 'px',
              height: (i.height / 710) * (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) + 'px',
              cursor: 'pointer',
            }"
          ></div>
        </div>
        <!-- 未登录     -->
        <div
          class="hot_wrap"
          v-if="item.json_data && item.json_data.type === 'pic_hot' && !loginFlag"
          :style="{
            height:(item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336)
            * (item.json_data.data.height / item.json_data.data.width) +
              'px',
            width: item.json_data.data.wSet === 'noset' ? '100%' : '1336px',
            margin: 'auto',
            marginBottom:'40px',
            paddingTop: item.json_data.padding_top + 'px',
            // paddingBottom: item.json_data.padding_bottom === '0' || item.json_data.padding_bottom === 0 ? '0px' : '40px',
            // paddingBottom:isShowHotPic? '40px':'0px',
            backgroundImage: 'url(' + item.json_data.data.img + ')',
            backgroundSize:
              item.json_data.data.wSet === 'noset' ? 'cover' : 'contain',
            backgroundPosition:
              item.json_data.data.wSet === 'noset' ? 'center' : 'center',
          }"
        >
          <div
            class="hot_area_div"
            v-for="(i, index1) in item.json_data.data.items"
            @click="diyNavTo(i)"
            :key="index1"
            :style="{
              top: (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) * (i.y / 710) + 'px',
              left: (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) * (i.x / 710) + 'px',
              width: (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) * (i.width / 710) + 'px',
              height: (i.height / 710) * (item.json_data.data.wSet === 'noset' ? (winWidth - 17) : 1336) + 'px',
              cursor: 'pointer',
            }"
          ></div>
        </div>
        <!-- 热区切图end -->

        <!-- adv_01 start广告一行一个-->
        <div
          class="adv_01_wrap"
          v-if="item.json_data && item.json_data.type == 'adv_01'"
          :class="{
            adv_01_wrap_full:
              item.json_data.full_screen && item.json_data.full_screen == 1,
          }"
          :style="{
            height: item.json_data.data.height + 'px',
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: background,
          }"
        >
          <a href="javascript:void(0)" @click="diyNavTo(item.json_data.data)">
            <img class="adv_01_img" style="width: 1336px;height: 320px;object-fit: cover;" v-bind:src="item.json_data.data.imgUrl" />
          </a>
        </div>
        <!-- adv_01 end-->

        <!-- adv_02 start-->
        <div
          class="adv_02_part"
          v-if="item.json_data && item.json_data.type == 'adv_02'"
          :style="{
            height:
              (item.json_data.padding_top ? item.json_data.padding_top : 0) +
              (item.json_data.padding_bottom
                ? item.json_data.padding_bottom
                : 0) +
              344 +
              'px',
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_02_left" @click="diyNavTo(item.json_data.left.data)">
            <a
              href="javascript:void(0)"
              v-if="item.json_data.left.data.imgUrl != undefined"
            >
              <img v-bind:src="item.json_data.left.data.imgUrl" />
            </a>
          </div>
          <div class="adv_02_center">
            <span class="split_h"></span>
            <div
              class="goods_item clearfix"
              v-for="(item_center, index_center) in item.json_data.center.data
                .goods_data"
              v-bind:key="index_center"
              @click="goGoodsDetail(item_center)"
            >
              <a target="_blank" href="javascript:void(0)">
                <div class="left">
                  <img v-bind:src="item_center.mainImage" />
                </div>
                <div class="right">
                  <p class="goods_name">{{ item_center.goodsName }}</p>
                  <p class="buy_num">
                    {{
                      item_center.actualSales * 1 +
                      item_center.virtualSales * 1
                    }}{{ L["人购买"] }}
                  </p>
                  <div class="price">
                    <span class="unit">&yen;</span>
                    <span class="integer">{{ item_center.goodsPrice }}</span>
                  </div>
                  <a class="buy" href="javascript:void(0)">{{
                    L["立即抢购"]
                  }}</a>
                </div>
              </a>
            </div>
            <span class="split_v"></span>
          </div>
          <div class="adv_02_right">
            <span
              class="right_img_item"
              v-for="(item_right, index_right) in item.json_data.right.data"
              v-bind:key="index_right"
              @click="diyNavTo(item_right)"
            >
              <a href="javascript:void(0)">
                <img v-bind:src="item_right.imgUrl" />
              </a>
            </span>
          </div>
        </div>
        <!-- adv_02 end-->

        <!-- adv_04 start-->
        <div
          class="w_sld_react_1210 adv_04_wrap"
          v-if="item.json_data && item.json_data.type == 'adv_04'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="floor_title">
            <h2>
              <span
                v-bind:style="{
                  backgroundColor: item.json_data.title_info.title_color,
                }"
                >&nbsp;</span
              >
              <span
                v-bind:style="{ color: item.json_data.title_info.title_color }"
                >{{ item.json_data.title_info.title_name }}</span
              >
              <span
                v-bind:style="{
                  backgroundColor: item.json_data.title_info.title_color,
                }"
                >&nbsp;</span
              >
            </h2>
          </div>
          <div class="floor_goods">
            <div
              class="item"
              v-for="(item_main, index_main) in item.json_data.data.goods_data"
              v-bind:key="index_main"
            >
              <div class="wrap" @click="goGoodsDetail(item_main)">
                <a href="javascript:void(0)" class="example_text">
                  <img v-bind:src="item_main.mainImage" />
                </a>
                <p class="title">
                  <a href="javascript:void(0)" title>{{
                    item_main.goodsName
                  }}</a>
                </p>
                <p class="price">
                  <span>
                    {{ L["¥"] }}
                    <span class="money_number">{{
                      item_main.goodsPrice || 0.0
                    }}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- adv_04 end-->

        <!-- adv_05 start-->
        <div
          class="w_sld_react_1210 adv_05_wrap"
          v-if="item.json_data && item.json_data.type == 'adv_05'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="floor">
            <div class="floor_layout">
              <div>
                <div class="floor_title">
                  <h2>
                    <span class="main_title">{{
                      item.json_data.title_info.title.initialValue
                    }}</span>
                    <span class="sub_title">{{
                      item.json_data.title_info &&
                      item.json_data.title_info.sub_title.initialValue
                    }}</span>
                  </h2>
                  <div
                    class="right_action"
                    v-if="item.json_data.title_info.link_type"
                  >
                    <a @click="diyNavTo(item.json_data.title_info)">
                      {{ L["查看更多"] }}
                      <i>&gt;&gt;</i>
                    </a>
                  </div>
                </div>

                <div class="floor_content">
                  <div class="floor_left">
                    <div class="floor_bg_img">
                      <a
                        class="ad_img example_text"
                        href="javascript:void(0)"
                        @click="diyNavTo(item.json_data.left.data)"
                      >
                        <img v-bind:src="item.json_data.left.data.imgUrl" />
                      </a>
                    </div>
                    <div class="floor_words">
                      <div class="floor_words_top_title">
                        <span></span>
                        <span>{{
                          item.json_data.left.cat_data.title_info.title_name
                        }}</span>
                        <span></span>
                      </div>
                      <ul>
                        <li
                          v-for="(item_left_cat, index_left_cat) in item
                            .json_data.left.cat_data.cat_datas"
                          v-bind:key="index_left_cat"
                        >
                          <a
                            href="javascript:void(0)"
                            :title="item_left_cat.categoryName"
                            @click="
                              goGoodsListByCatId(item_left_cat.categoryId)
                            "
                            >{{ item_left_cat.categoryName }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    class="floor_right"
                    style="border-color: var(--color_main)"
                  >
                    <div class="floor_right_main">
                      <div class="floor_content">
                        <div
                          class="big_item item"
                          v-if="item.json_data.center.data.goods_data.length"
                        >
                          <div
                            class="wrap"
                            @click="
                              goGoodsDetail(
                                item.json_data.center.data.goods_data[0]
                              )
                            "
                          >
                            <div class="left_pic">
                              <a
                                href="javascript:void(0)"
                                class="ad_img example_text"
                              >
                                <img
                                  v-bind:src="
                                    item.json_data.center.data.goods_data[0]
                                      .mainImage
                                  "
                                  alt="item.json_data.center.data.goods_data[0].goodsName"
                                />
                              </a>
                            </div>
                            <div class="right_info">
                              <p class="title">
                                <a
                                  href="javascript:void(0)"
                                  :title="
                                    item.json_data.center.data.goods_data[0]
                                      .goodsName
                                  "
                                  >{{
                                    item.json_data.center.data.goods_data[0]
                                      .goodsName
                                  }}</a
                                >
                              </p>
                              <p class="price">
                                {{ L["¥"] }}
                                <span class="money_number">{{
                                  item.json_data.center.data.goods_data[0]
                                    .goodsPrice
                                }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          class="item"
                          v-if="
                            item.json_data.center.data.goods_data.length > 1
                          "
                        >
                          <div
                            class="wrap"
                            @click="
                              goGoodsDetail(
                                item.json_data.center.data.goods_data[1]
                              )
                            "
                          >
                            <a class="ad_img" href="javascript:void(0)">
                              <img
                                v-bind:src="
                                  item.json_data.center.data.goods_data[1]
                                    .mainImage
                                "
                                alt="item.json_data.center.data.goods_data[1].goodsName"
                              />
                            </a>
                            <p class="title">
                              <a
                                href="javascript:void(0)"
                                :title="
                                  item.json_data.center.data.goods_data[1]
                                    .goodsName
                                "
                                >{{
                                  item.json_data.center.data.goods_data[1]
                                    .goodsName
                                }}</a
                              >
                            </p>
                            <p class="price">
                              {{ L["¥"] }}
                              <span class="money_number">{{
                                item.json_data.center.data.goods_data[1]
                                  .goodsPrice
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <template
                          v-for="(
                            item_center_bottom, index_center_bottom
                          ) in item.json_data.center.data.goods_data"
                        >
                          <div
                            class="item bottom_item"
                            :key="index_center_bottom"
                            v-if="index_center_bottom > 1"
                            @click="goGoodsDetail(item_center_bottom)"
                          >
                            <div class="wrap">
                              <a
                                href="javascript:void(0)"
                                class="ad_img example_text"
                              >
                                <img
                                  v-bind:src="item_center_bottom.mainImage"
                                  alt="item_center_bottom.goodsName"
                                />
                              </a>
                              <p class="title">
                                <a
                                  href="javascript:void(0)"
                                  :title="item_center_bottom.goodsName"
                                  >{{ item_center_bottom.goodsName }}</a
                                >
                              </p>
                              <p class="price">
                                {{ L["¥"] }}
                                <span class="money_number">{{
                                  item_center_bottom.goodsPrice
                                }}</span>
                              </p>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="floor_right_new">
                      <div class="floor_right_new_top_title">
                        <span style="background: #fc585a"></span>
                        <span style="color: #fc585a">{{
                          item.json_data.right.title_info.title_name
                        }}</span>
                        <span style="background: #fc585a"></span>
                      </div>
                      <div class="floor_content">
                        <div
                          class="item"
                          v-for="(item_right_goods, index_right_goods) in item
                            .json_data.right.data.goods_data"
                          v-bind:key="index_right_goods"
                        >
                          <div
                            class="wrap"
                            @click="goGoodsDetail(item_right_goods)"
                          >
                            <div class="left_pic">
                              <a
                                href="javascript:void(0)"
                                class="ad_img example_text"
                              >
                                <img
                                  v-bind:src="item_right_goods.mainImage"
                                  alt="item_right_goods.goodsName"
                                />
                              </a>
                            </div>
                            <div class="right_info">
                              <p class="title">
                                <a
                                  href="javascript:void(0)"
                                  :title="item_right_goods.goodsName"
                                  >{{ item_right_goods.goodsName }}</a
                                >
                              </p>
                              <p class="price">
                                {{ L["¥"] }}
                                <span class="money_number">{{
                                  item_right_goods.goodsPrice
                                }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- adv_05 end-->

        <!-- adv_06 start广告一行4个-->
        <div
          v-if="item.json_data && item.json_data.type == 'adv_06'"
          class="adv_06"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_06_wrap">
            <div
              class="item"
              v-for="(item_child, index_child) in item.json_data.data"
              v-bind:key="index_child"
            >
              <a href="javascript:void(0)" @click="diyNavTo(item_child)">
                <img v-bind:src="item_child.imgUrl" />
              </a>
            </div>
          </div>
        </div>
        <!-- adv_06 end-->

        <!-- adv_07一行三个 start-->
        <div
          class="adv_07"
          v-if="item.json_data && item.json_data.type == 'adv_07'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_07_wrap">
            <div
              class="item"
              v-for="(item_child, index_child) in item.json_data.data"
              :key="index_child"
            >
              <a
                href="javascript:void(0);"
                @click="diyNavTo(item_child)"
                v-if="item_child.imgUrl"
              >
                <img :src="item_child.imgUrl" />
              </a>
              <a class="show_tip" href="javascript:void(0);" v-else>
                <span>{{ L["此处添加【403*高度不限】图片"] }}</span>
              </a>
            </div>
          </div>
        </div>
        <!-- adv_07 一行三个end-->

        <!-- adv_08 start广告一行五个-->
        <div
          class="w_sld_react_1210 adv_08 com_1210_center"
          v-if="item.json_data && item.json_data.type == 'adv_08'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_08_wrap">
            <div
              class="item"
              v-for="(item_main, index_main) in item.json_data.data"
              v-bind:key="index_main"
              @click="diyNavTo(item_main)"
            >
              <a href="javascript:void(0)">
                <img v-bind:src="item_main.imgUrl" />
              </a>
            </div>
          </div>
        </div>
        <!-- adv_08 end-->

        <!-- adv_09 start-->
        <div
          class="adv_09 com_1210_center"
          v-if="item.json_data && item.json_data.type == 'adv_09'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_09_wrap">
            <div class="item left">
              <div
                class="top_title"
                v-bind:style="{
                  backgroundColor:
                    item.json_data.left.title_info.title_bg_color,
                  color: item.json_data.left.title_info.title_color,
                }"
              >
                {{ item.json_data.left.title_info.title_name }}
              </div>

              <div class="main_con">
                <a
                  class="first show_tip"
                  href
                  v-for="(item_left, index_left) in item.json_data.left.data"
                  v-bind:key="index_left"
                  @click="diyNavTo(item_left)"
                >
                  <img v-bind:src="item_left.imgUrl" />
                </a>
              </div>
            </div>
            <div class="item center">
              <div
                class="top_title"
                v-bind:style="{
                  backgroundColor:
                    item.json_data.center.title_info.title_bg_color,
                  color: item.json_data.center.title_info.title_color,
                }"
              >
                {{ item.json_data.center.title_info.title_name }}
              </div>
              <div class="main_con">
                <a
                  class="show_tip"
                  href
                  v-for="(item_center, index_center) in item.json_data.center
                    .data"
                  v-bind:key="index_center"
                  @click="diyNavTo(item_center)"
                >
                  <img v-bind:src="item_center.imgUrl" />
                </a>
              </div>
            </div>
            <div class="item right">
              <div
                class="top_title"
                v-bind:style="{
                  backgroundColor:
                    item.json_data.right.title_info.title_bg_color,
                  color: item.json_data.right.title_info.title_color,
                }"
              >
                {{ item.json_data.right.title_info.title_name }}
              </div>
              <div class="main_con">
                <a
                  class="show_tip"
                  href
                  v-for="(item_right, index_right) in item.json_data.right.data"
                  v-bind:key="index_right"
                  @click="diyNavTo(item_right)"
                >
                  <img v-bind:src="item_right.imgUrl" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- adv_09 end-->

        <!-- adv_10 start-->
        <div
          class="adv_10 com_1210_center"
          v-if="item.json_data && item.json_data.type == 'adv_10'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_10_wrap">
            <div
              class="row_one"
              v-for="(item_one, index_one) in item.json_data.row_one.data"
              v-bind:key="index_one"
            >
              <a href="javascript:void(0)" @click="diyNavTo(item_one)">
                <img v-bind:src="item_one.imgUrl" />
              </a>
            </div>
            <div class="row_four">
              <a
                href="javascript:void(0)"
                v-for="(item_four, index_four) in item.json_data.row_four.data"
                v-bind:key="index_four"
                @click="diyNavTo(item_four)"
              >
                <img v-bind:src="item_four.imgUrl" />
              </a>
            </div>
            <div class="row_five">
              <a
                href="javascript:void(0)"
                v-for="(item_five, index_five) in item.json_data.row_five.data"
                v-bind:key="index_five"
                @click="diyNavTo(item_five)"
              >
                <img v-bind:src="item_five.imgUrl" />
              </a>
            </div>
          </div>
        </div>
        <!-- adv_10 end-->

        <!-- adv_11 start-->
        <div
          class="adv_11 com_1210_center"
          v-if="item.json_data && item.json_data.type == 'adv_11'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_11_wrap">
            <div class="item row_left">
              <a
                href="javascript:void(0)"
                v-for="(item_left, index_left) in item.json_data.row_left.data"
                v-bind:key="index_left"
                v-bind:class="{ lb_margin: index_left % 2 == 1 }"
                @click="diyNavTo(item_left)"
              >
                <img v-bind:src="item_left.imgUrl" />
              </a>
            </div>
            <div class="item row_right">
              <div class="top">
                <a
                  href="javascript:void(0)"
                  v-if="item.json_data.row_right.top.data[0] != undefined"
                  @click="diyNavTo(item.json_data.row_right.top.data[0])"
                >
                  <img
                    v-bind:src="item.json_data.row_right.top.data[0].imgUrl"
                  />
                </a>
              </div>
              <div class="bottom">
                <a
                  href="javascript:void(0)"
                  v-if="item.json_data.row_right.bottom.data[0] != undefined"
                  @click="diyNavTo(item.json_data.row_right.bottom.data[0])"
                >
                  <img
                    v-bind:src="item.json_data.row_right.bottom.data[0].imgUrl"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- adv_11 end-->

        <!-- adv_12 start-->
        <div
          class="adv_12 com_1210_center"
          v-if="item.json_data && item.json_data.type == 'adv_12'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_12_wrap">
            <div class="item left clear_padding">
              <a
                class="l_img"
                href="javascript:void(0)"
                @click="diyNavTo(item.json_data.left.data[0])"
              >
                <img v-bind:src="item.json_data.left.data[0].imgUrl" />
              </a>
            </div>
            <div class="item center">
              <a
                v-for="(item_center, index_center) in item.json_data.center
                  .data"
                v-bind:key="index_center"
                v-bind:class="{ l_b_margin: index_center % 2 == 1 }"
                @click="diyNavTo(item_center)"
              >
                <img v-bind:src="item_center.imgUrl" />
              </a>
            </div>
            <div class="item right">
              <div
                class="title_wrap"
                @click="diyNavTo(item.json_data.right.title_info)"
              >
                <a class="title" href="javascript:void(0)">{{
                  item.json_data.right.title_info.title.initialValue
                }}</a>
                <span> 》</span>
                <a href="javascript:void(0)" class="subtitle">{{
                  item.json_data.right.title_info.sub_title.initialValue
                }}</a>
              </div>
              <div class="img_top">
                <a
                  href="javascript:void(0)"
                  @click="diyNavTo(item.json_data.right.top.data[0])"
                >
                  <img v-bind:src="item.json_data.right.top.data[0].imgUrl" />
                </a>
              </div>
              <div class="img_bottom">
                <a
                  class="l_img"
                  href="javascript:void(0)"
                  v-for="(item_right_bottom, index_right_bottom) in item
                    .json_data.right.bottom.data"
                  v-bind:key="index_right_bottom"
                  @click="diyNavTo(item_right_bottom)"
                >
                  <img v-bind:src="item_right_bottom.imgUrl" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- adv_12 end-->

        <!-- adv_13 start-->
        <div
          class="w_sld_react_1210 adv_13 com_1210_center"
          v-if="item.json_data && item.json_data.type == 'adv_13'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_13_wrap">
            <div
              class="item right"
              @click="diyNavTo(item.json_data.left.title_info)"
            >
              <div class="title_wrap">
                <a class="title" href="javascript:void(0)">{{
                  item.json_data.left.title_info.title.initialValue
                }}</a>
                <span> 》</span>
                <a class="subtitle" href="javascript:void(0)">{{
                  item.json_data.left.title_info.sub_title.initialValue
                }}</a>
              </div>
              <div class="img_top">
                <a
                  class
                  href="javascript:void(0)"
                  @click="diyNavTo(item.json_data.left.top.data[0])"
                >
                  <img v-bind:src="item.json_data.left.top.data[0].imgUrl" />
                </a>
              </div>
              <div class="img_bottom">
                <a
                  class
                  href="javascript:void(0)"
                  v-for="(item_left_bottom, index_left_bottom) in item.json_data
                    .left.bottom.data"
                  v-bind:key="index_left_bottom"
                  v-bind:class="{ l_b_margin: index_left_bottom % 2 == 0 }"
                  @click="diyNavTo(item_left_bottom)"
                >
                  <img v-bind:src="item_left_bottom.imgUrl" />
                </a>
              </div>
            </div>
            <div class="item right">
              <div
                class="title_wrap"
                @click="diyNavTo(item.json_data.center.title_info)"
              >
                <a class="title" href="javascript:void(0)">{{
                  item.json_data.center.title_info.title.initialValue
                }}</a>
                <span> 》</span>
                <a class="subtitle" href="javascript:void(0)">{{
                  item.json_data.center.title_info.sub_title.initialValue
                }}</a>
              </div>
              <div class="img_top">
                <a
                  href="javascript:void(0)"
                  @click="diyNavTo(item.json_data.center.top.data[0])"
                >
                  <img v-bind:src="item.json_data.center.top.data[0].imgUrl" />
                </a>
              </div>
              <div class="img_bottom">
                <a
                  class="l_img"
                  href="javascript:void(0)"
                  v-for="(item_center_bottom, index_center_bottom) in item
                    .json_data.center.bottom.data"
                  v-bind:key="index_center_bottom"
                  @click="diyNavTo(item_center_bottom)"
                >
                  <img v-bind:src="item_center_bottom.imgUrl" />
                </a>
              </div>
            </div>
            <div class="item left clear_padding">
              <a
                class="l_img"
                href="javascript:void(0)"
                @click="diyNavTo(item.json_data.right.data[0])"
              >
                <img :src="item.json_data.right.data[0].imgUrl" />
              </a>
            </div>
          </div>
        </div>
        <!-- adv_13 end-->

        <!-- adv_19 start-->
        <div
          class="w_sld_react_1210 adv_19"
          v-if="item.json_data && item.json_data.type == 'adv_19'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_19_wrap">
            <div
              v-for="(items, index) in item.json_data.data"
              :key="index"
              class="item left"
            >
              <div
                class="top_title"
                :style="{
                  backgroundColor: items.top.title_info.title_bg_color,
                }"
              >
                <div
                  class="l_title"
                  :style="{ color: items.top.title_info.title_color }"
                >
                  {{
                    items.top.title_info.title_name
                      ? items.top.title_info.title_name
                      : L["添加标题"]
                  }}
                </div>
                <div class="r_title">
                  <ul>
                    <li
                      v-for="(val, key) in items.center.right"
                      :key="key"
                      :class="{ sel_tab: key == items.cur_tab }"
                      @mouseover="adv19Tab(item.dataId, index, key, items)"
                    >
                      <span class="con">
                        {{
                          val.title_info.title_name
                            ? val.title_info.title_name
                            : L["添加内容"]
                        }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="center">
                <div class="l_center">
                  <a
                    href="javascript:;"
                    @click="diyNavTo(items.center.left.data[0])"
                  >
                    <img
                      v-if="items.center.left.data[0].imgUrl"
                      :src="items.center.left.data[0].imgUrl"
                    />
                    <span v-else>{{ L["此处添加【186*340】图片"] }}</span>
                  </a>
                </div>
                <div class="r_center">
                  <div class="tabs_panel">
                    <div
                      v-for="(val, key) in items.center.right[items.cur_tab]
                        .data"
                      :key="key"
                      class="item"
                    >
                      <div class="title_wrap">
                        <a
                          class="main_title"
                          href="javascript:;"
                          @click="diyNavTo(val)"
                        >
                          {{ val.main_title ? val.main_title : L["图片标题"] }}
                        </a>
                        <a
                          class="sub_title"
                          href="javascript:;"
                          @click="diyNavTo(val)"
                        >
                          {{ val.sub_title ? val.sub_title : L["图片子标题"] }}
                        </a>
                      </div>

                      <div class="bottom_img">
                        <a
                          class="sld_com_no_img"
                          href="javascript:;"
                          @click="diyNavTo(val)"
                        >
                          <img v-if="val.imgUrl" :src="val.imgUrl" />
                          <span v-else>{{ L["此处添加【172*106】图片"] }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bottom">
                <a
                  v-for="(val, key) in items.bottom.data"
                  :key="key"
                  class="sld_com_no_img"
                  href="javascript:;"
                  @click="diyNavTo(val)"
                >
                  <img v-if="val.imgUrl" :src="val.imgUrl" />
                  <span v-else>{{ L["此处添加【187*120】图片"] }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- adv_19 end-->

        <!-- adv_20 金刚导航 start-->
        <div
          class="w_sld_react_1210 adv_20"
          v-if="item.json_data && item.json_data.type == 'adv_20'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_20_wrap">
            <div
              class="adv_20_wrap_item"
              v-for="(val, key) in item.json_data.data"
              :key="key"
            >
              <div
                class="adv_20_wrap_item_img"
                style="border-radius: 0px"
                @click="diyNavTo(val)"
              >
                <img :src="val.imgUrl" />
              </div>
              <span class="main_title" @click="diyNavTo(val)">{{
                val.main_title
              }}</span>
              <!-- <span class="sub_title" @click="diyNavTo(val)">{{
                val.sub_title
              }}</span> -->
            </div>
          </div>
        </div>
        <!-- adv_20金刚导航 end-->

        <!-- adv_21 start-->
        <div
          class="w_sld_react_1210 adv_21"
          v-if="item.json_data && item.json_data.type == 'adv_21'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
            backgroundColor: item.json_data.bg_color,
          }"
        >
          <div class="adv_21_wrap flex_row_start_start">
            <div
              class="flex_column_start_start adv_21_wrap_item"
              v-for="(val1, key1) in item.json_data.data"
              :key="key1"
            >
              <div
                class="flex_row_between_center title_part"
                @click="diyNavTo(val1)"
              >
                <span class="title">{{
                  val1.top_title.title.initialValue
                }}</span>
                <a class="view_more"
                  >{{ val1.top_title.sub_title.initialValue }}&gt;</a
                >
              </div>
              <div class="flex_column_start_start detail">
                <div
                  class="flex_row_start_start item"
                  v-for="(val2, key2) in val1.detail"
                  :key="key2"
                >
                  <div class="item_left" @click="diyNavTo(val2.left)">
                    {{ val2.left.title.initialValue }}
                  </div>
                  <div class="flex_row_start_center item_right">
                    <span
                      class="item_right_con"
                      v-for="(val3, key3) in val2.right"
                      :key="key3"
                      @click="diyNavTo(val3)"
                    >
                      {{ val3.title.initialValue }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- adv_21 end-->

        <!-- 1图+8商品start -->
        <!-- <div
          class="adv_title_container"
          v-if="item.json_data && item.json_data.type == 'oneEight'"
        >
          <div class="adv_title">新品专区</div>
          <div class="view_info" v-show="isViewInfoVisible">
            <span>查看详情</span>
            <img src="../assets/arrow.png" alt="" />
          </div>
        </div> -->

        <div
          class="w_sld_react_1210 adv_goods_18"
          v-if="item.json_data && item.json_data.type == 'oneEight'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
          }"
        >
          <div class="adv_goods_18_wrap">
            <div @click="diyNavTo(item.json_data.data)" class="left">
              <a
                class="l_img"
                href="javascript:void(0)"
                @click="diyNavTo(item.json_data.data)"
              >
                <img
                  style="
                    width: 296px;
                    height: 671px;
                    margin-bottom: 10px;
                    background: #ffe1e1;
                  "
                  :src="item.json_data.data.imgUrl"
                  alt=""
                />
              </a>
            </div>
            <div class="right">
              <div
                v-for="(goods, ind) in item.json_data.info"
                :key="ind"
                @click="goGoodsDetail(goods)"
                class="item"
                :class="ind < 4 ? 'goods_bottom' : ''"
              >
                <div v-if="goods.fresh">
                  <img
                    style="width: 170px; height: 170px; margin: 20px 0 10px"
                    :src="
                      item.json_data.imgType == 'whiteBg'
                        ? goods.writeImageUrl
                          ? goods.writeImageUrl
                          : goods.mainImageUrl
                        : goods.mainImageUrl
                    "
                  />
                  <div v-if="goods.newProdcut" class="flex_row_center_center ">
                    <img
                      style="width: 30px; height: 18px; margin-right: 5px"
                      src="../assets/new_product.png"
                      alt=""
                      v-if="goods.newProdcut"
                    />
                    <!-- <div class="limit_activity" v-if="goods.productShortTitle">
                    {{ goods.productShortTitle }}
                  </div> -->
                    <div class="title ellipsis_pp" >{{ goods.productShortTitle }}</div>
                  </div>
                  <div v-else class="flex_row_center_center ">
                    <!-- <div class="limit_activity" v-if="goods.productShortTitle">
                    {{ goods.productShortTitle }}
                  </div> -->
                    <div class="title ellipsis" >{{ goods.productShortTitle }}</div>
                  </div>
                  <div class="sub_title">
                    {{ goods.specValues }}
                  </div>
                  <div class="flex_row_center_center">
                    <!-- <div class="activity_list">
                      <div
                        class="activity_tips"
                        style="color: #fc5b4f; border-color: #fc5b4f"
                      >
                        首单
                      </div>
                    </div> -->
                    <div
                      v-if="
                        goods.activityList && goods.activityList.length != 0
                      "
                      class="flex_row_center_center" style="height:40px;width:100%"
                    >
                      <div
                        v-for="(i, ind) in goods.activityList"
                        :key="ind"
                        class="activity_list"
                      >
                        <div class="activity_tips"
                        :style="
                            i.promotionName == '首单' ||
                            i.promotionName == '预约' ||
                            i.promotionName == '专享' ||
                            i.promotionName == '预售'
                              ? 'color: #fc5b4f; border-color: #fc5b4f'
                              : ''
                          "
                          v-if="i.promotionName && i.promotionName != '新品'">{{ i.promotionName }}</div>
                      </div>
                    </div>
                    <div v-else style="height:40px;width:100%"></div>
                    <!-- <div class="activity_tips red_tips">领券立减300</div> -->
                  </div>
                  <div
                    style="width: 100%; height: 38px"
                    v-if="!goods.activityList"
                  ></div>
                  <div class="hot_recommend_pre_price flex_row_center_center">
                    <span
                      >￥{{
                        goods.activityPrice
                          ? goods.activityPrice
                          : goods.productPrice
                      }}&nbsp;&nbsp;</span
                    >
                    <span v-if="goods.activityPrice">￥{{ goods.productPrice }}</span>
                  </div>
                </div>
                <div v-else></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 1图+8商品end -->
        <!-- 2图+8商品start -->
        <div
          class="w_sld_react_1210 adv_goods_28"
          v-if="item.json_data && item.json_data.type == 'twoEight'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
          }"
        >
          <div class="adv_goods_28_wrap">
            <div @click="diyNavTo(item.json_data.data)" class="left">
              <!-- <a > -->
              <img
                @click="diyNavTo(item.json_data.data[0])"
                style="
                  width: 296px;
                  height: 328px;
                  margin-bottom: 15px;
                  background: #ffe1e1;
                "
                :src="item.json_data.data[0].imgUrl"
                alt=""
              />
              <!-- </a> -->
              <!-- <a
                href="javascript:void(0)"
               
              > -->
              <img
                @click="diyNavTo(item.json_data.data[1])"
                style="width: 296px; height: 328px; background: #ffe1e1"
                :src="item.json_data.data[1].imgUrl"
                alt=""
              />
              <!-- </a> -->
            </div>
            <div class="right">
              <div
                v-for="(goods, ind) in item.json_data.info"
                :key="ind"
                @click="goGoodsDetail(goods)"
                class="item"
                :class="ind < 4 ? 'goods_bottom' : ''"
              >
                <div v-if="goods.fresh">
                  <img
                    style="width: 170px; height: 170px; margin: 20px 0 10px"
                    :src="
                      item.json_data.imgType == 'whiteBg'
                        ? goods.writeImageUrl
                          ? goods.writeImageUrl
                          : goods.mainImageUrl
                        : goods.mainImageUrl
                    "
                  />
                  <div class="flex_row_center_center">
                    <img
                      style="width: 30px; height: 18px; margin-right: 5px"
                      src="../assets/new_product.png"
                      alt=""
                      v-if="goods.newProdcut"
                    />
                    <!-- <div class="limit_activity" v-if="goods.productShortTitle">
                    {{ goods.productShortTitle }}
                  </div> -->
                    <div class="title" style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;margin-left: 12px;margin-right: 12px; ">{{ goods.productShortTitle }}</div>
                  </div>
                  <div class="sub_title">
                    {{ goods.specValues}}
                  </div>
                  <div class="flex_row_center_center">
                    <!-- <div class="activity_list">
                      <div
                        class="activity_tips"
                        style="color: #fc5b4f; border-color: #fc5b4f"
                      >
                        首单
                      </div>
                    </div> -->
                    <div
                      v-if="
                        goods.activityList && goods.activityList.length != 0
                      "
                      class="flex_row_center_center"
                      style="height:40px;width:100%;"
                    >
                      <div
                        v-for="(i, ind) in goods.activityList"
                        :key="ind"
                        class="activity_list"
                      >
                        <div class="activity_tips"
                        :style="
                            i.promotionName == '首单' ||
                            i.promotionName == '预约' ||
                            i.promotionName == '专享' ||
                            i.promotionName == '预售'
                              ? 'color: #fc5b4f; border-color: #fc5b4f'
                              : ''
                          "
                          v-if="i.promotionName && i.promotionName != '新品'">{{ i.promotionName }}</div>
                      </div>
                    </div>
                    <div v-else style="height:40px;width:100%;"></div>
                    <!-- <div class="activity_tips red_tips">领券立减300</div> -->
                  </div>
                  <div
                    style="width: 100%; height: 38px"
                    v-if="!goods.activityList"
                  ></div>
                  <div class="hot_recommend_pre_price flex_row_center_center">
                    <span
                      >￥{{
                        goods.activityPrice
                          ? goods.activityPrice
                          : goods.productPrice
                      }}&nbsp;&nbsp;</span
                    >
                    <span v-if="goods.activityPrice">￥{{ goods.productPrice }}</span>
                  </div>
                </div>
                <div v-else></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 2图+8商品end -->

        <!-- 一行5商品start -->

        <div
          class="w_sld_react_1210 adv_goods_15"
          v-if="item.json_data && item.json_data.type == 'zeroFive'"
          :style="{
            paddingTop: item.json_data.padding_top + 'px',
            paddingBottom: item.json_data.padding_bottom + 'px',
          }"
        >
          <div class="adv_goods_15_wrap">
            <div
              class="item"
              v-for="(item_main, index_main) in item.json_data.info"
              v-bind:key="index_main"
              @click="goGoodsDetail(item_main)"
            >
              <div v-if="item_main.fresh">
                <a href="javascript:void(0)">
                  <img
                    style="width: 170px; height: 170px; margin: 20px 0 10px"
                    :src="
                      item.json_data.imgType == 'whiteBg'
                        ? item_main.writeImageUrl
                          ? item_main.writeImageUrl
                          : item_main.mainImageUrl
                        : item_main.mainImageUrl
                    "
                  />
                  <div class="flex_row_center_center">
                    <img
                      style="width: 30px; height: 18px; margin-right: 5px"
                      src="../assets/new_product.png"
                      alt=""
                      v-if="item_main.newProdcut"
                    />
                    <!-- <div
                    class="limit_activity"
                    v-if="item_main.productShortTitle"
                  >
                    {{ item_main.productShortTitle }}
                  </div> -->
                    <div class="title">{{ item_main.productShortTitle }}</div>
                  </div>
                  <div class="sub_title">
                    {{ item_main.specValues }}
                  </div>
                  <div class="flex_row_center_center">
                    <!-- <div class="activity_list">
                    <div
                      class="activity_tips"
                      style="color: #fc5b4f; border-color: #fc5b4f"
                    >
                      首单
                    </div>
                  </div> -->
                    <div
                      v-if="
                        item_main.activityList &&
                        item_main.activityList.length != 0
                      "
                      class="flex_row_center_center"
                      style="height:40px;width:100%"
                    >
                      <div
                        v-for="(i, ind) in item_main.activityList"
                        :key="ind"
                        class="activity_list"
                      >
                        <div
                          class="activity_tips"
                          :style="
                            i.promotionName == '首单' ||
                            i.promotionName == '预约' ||
                            i.promotionName == '专享' ||
                            i.promotionName == '预售'
                              ? 'color: #fc5b4f; border-color: #fc5b4f'
                              : ''
                          "
                          v-if="i.promotionName && i.promotionName != '新品'"
                        >
                          {{ i.promotionName }}
                        </div>
                      </div>
                    </div>
                    <div v-else style="height:40px;width:100%"></div>
                    <!-- <div class="activity_tips red_tips">领券立减300</div> -->
                  </div>
                  <div
                    style="width: 100%; height: 38px"
                    v-if="!item_main.activityList"
                  ></div>
                  <div class="hot_recommend_pre_price flex_row_center_center">
                    <span
                      >￥{{
                        item_main.activityPrice
                          ? item_main.activityPrice
                          : item_main.productPrice
                      }}&nbsp;&nbsp;</span
                    >
                    <span v-if="item_main.activityPrice">￥{{ item_main.productPrice }}</span>
                  </div>
                </a>
              </div>
              <div v-else></div>
            </div>
          </div>
        </div>
        <!-- 一行5商品end -->
        <!-- 文本标题start -->
        <div
          class="adv_title_container"
          :style="{
            background: item.json_data.data.bgColor,
            marginTop: item.json_data.padding_top + 'px',
            marginBottom: item.json_data.padding_bottom + 'px',
          }"
          v-if="item.json_data && item.json_data.type == 'text_title'"
          @click="diyNavTo(item.json_data.data)"
          :ref="'scroll' + item.json.data.id"
        >
          <div class="adv_title_center" style="line-height: 50px">
            <div
              class="adv_title"
              v-if="item.json_data.data.position == 'left'"
              :style="{ color: item.json_data.data.titleColor }"
            >
              {{ item.json_data.data.titleName }}
            </div>
          </div>

          <div
            class="adv_title_center"
            style="text-align: center; line-height: 50px"
          >
            <div
              class="adv_title"
              v-if="item.json_data.data.position != 'left'"
              :style="{ color: item.json_data.data.titleColor }"
            >
              {{ item.json_data.data.titleName }}
            </div>
          </div>
          <div
            class="adv_title_center view_info"
            v-if="item.json_data.data.seeMore == true"
          >
            <span>{{ item.json_data.data.moreTitle }}</span>
            <img src="../assets/arrow.png" alt="" />
          </div>
        </div>
        <!-- 文本标题end -->
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, ref, onMounted, watch,computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
export default {
  name: "SldDiy",
  props: {
    decorateData: Object, //装修的数据
    source: String, //来源，home:平台首页  store:店铺装修
    background: String,
    banner: Array,
    isTopic: Boolean,
  },
  setup(props) {

    const winWidth = ref(window.innerWidth);
    
    const route = useRoute();
    const store = useStore();
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const isViewInfoVisible = ref(false);
    const isShowHotPic = ref(false);
    const isShowBanner = ref(false);
    const userCategoryId = '';
    const isNewMember = ref();
    const hotPicVisibility = ref(new Map());
    const bannerVisibility = ref(new Map());
    const bannerVisSet = ref(false)
    const bannerDatasSet = ref(false)
    const loginFlag = computed(() => store.state.loginFlag);
    // 定义一个方法来切换 isViewInfoVisible 的值
    const toggleViewInfo = () => {
      isViewInfoVisible.value = !isViewInfoVisible.value;
    };
    const liftData = ref([]);
    console.log(222, props.banner);
    const diyNavTo = (val) => {
      console.log("diyNavTo===", val);
      if (route.query.vid) {
        val.storeId = route.query.vid;
      }
      proxy.$diyNavTo(val);
    };
    const goGoodsDetail = (val) => {
      proxy.$goGoodsDetail(val.productId);
    };
    const goGoodsListByCatId = (val) => {
      proxy.$goGoodsListByCatId(val);
    };

    const updateWidth = () => {
      winWidth.value = window.innerWidth;
    };
    
    onMounted(() => {
      // getMemberInfo()
      hotPicDisplay();
      bannerDisplay();
      window.addEventListener('resize', updateWidth);
    });

    watch(
      () => props.decorateData,
      (oldVal, newVal) => {
        console.log("5477rt3rt45654");
        // props.decorateData = newVal;
        proxy.$emit("getDada");
      },
      { immediate: true }
    );
    watch(
      () => props.banner,
      (newVal) => {
        // searchBarFixed.value = newVal
        console.log(
          "watchprops.bannerprops.bannerprops.banner================>",
          props.banner
        );
        if(props.isTopic){
          bannerDatasSet.value = true
        } else{
          bannerDatasSet.value = props.banner.length > 0
        }
        
      },
      { immediate: true }
    );
    //adv_19楼层tab切换事件
    const adv19Tab = (dataId, index, key, items) => {
      items.cur_tab = key;
    };
    const dragEvent = (item) =>{
      let params = {
					banner_id: item.advId,
					banner_name: item.datas.imgName,
					amall_element_id: 0,
					page_path: route.path,
					page_url: item.datas.link_type || item.datas.url_type,
					page_type: 1
				}
			proxy.$drgStatEvent('banner_click',params)
    }

        // 检查所有轮播项的可见性
        const bannerDisplay = async () => {

            // console.log('[轮播检查] 开始检查所有轮播项可见性');
            if(loginFlag.value){
                const newVisibilityMap = new Map();
                try {
                // 获取会员信息（需要await等待异步结果）
                const memberInfo = await getMemberInfo();
                  const { userCategoryId, isNewMember } = memberInfo || {};
                  // console.log('[会员信息]', { userCategoryId, isNewMember });

                  // 遍历装修数据
                  props.decorateData.data.forEach((item, outerIndex) => {
                    if (!isMainBanner(item)) return;

                    item.json_data.data.forEach((bannerRaw, bannerIndex) => {
                      const compositeKey = bannerIndex;
                      const bannerData = safeParseBannerData(bannerRaw);
                      
                      // 空数据默认不可见
                      if (!bannerData) {
                        newVisibilityMap.set(compositeKey, false);
                        return;
                      }

                      const visibility = calculateBannerVisibility(bannerData, userCategoryId, isNewMember);
                      newVisibilityMap.set(compositeKey, visibility);
                      
                      // console.log(`[轮播${compositeKey}] 可见状态: ${visibility}`, bannerData);
                    });
                  });
              

              } catch (error) {
                console.error('[轮播检查错误]', error);
              } finally {
                bannerVisibility.value = newVisibilityMap; 
                bannerVisSet.value = true;
                console.log('[轮播可见性更新]', Array.from(newVisibilityMap.entries()));
              }
            } else {
              console.log("bannerDisplay== bannerVisSet.value==true")
              bannerVisSet.value = true;
            }
        };

        // 安全解析轮播数据
        const safeParseBannerData = (rawData) => {
          try {
            return JSON.parse(rawData.data);
          } catch (e) {
            console.error('[数据解析异常] 轮播项数据格式错误', rawData);
            return null;
          }
        };

        // 判断是否是主轮播组件
        const isMainBanner = (item) => {
          return item.json_data?.type === 'main_banner';
        };

        // 计算单个轮播项可见性
        const calculateBannerVisibility = (bannerData, userCategoryId, isNewMember) => {
          // 投放组策略判断（根据文档deliveryGroup必填）
          switch (bannerData.deliveryGroup) {
            case 1: // 全部可见
              // console.log('[策略1] 全部人群可见');
              return true;

            case 2: { // 特定条件可见
              // 新会员检查（兼容memberType不存在的情况）
              const isForNewMember = bannerData.memberType?.includes('new') ?? false;
              if (isForNewMember && isNewMember) {
                // console.log('[新会员] 满足新会员条件');
                return true;
              }

              // 指定会员类型检查（兼容designatedMemberType不存在/空数组）
              const designatedMembers = bannerData.designatedMemberType || [];
              const isSpecifiedMember = designatedMembers.some(id => id === userCategoryId);
              // console.log(`[指定会员] 检查结果: ${isSpecifiedMember}`, { 
              //   userCategoryId,
              //   designatedMembers 
              // });

              return isSpecifiedMember;
            }

            default:
              console.warn('[投放未开启] 默认可见');
              return true;
          }
        };


    // 检查所有热区切图的可见性
      const hotPicDisplay = async () => {
        // console.log('[热区切图] 开始检查所有热区切图可见性');
        const newVisibilityMap = new Map();
        
        try {
          // 先获取会员信息（假设是同步操作，如果是异步需要await）
          const memberInfo = await getMemberInfo();
          const { userCategoryId, isNewMember } = memberInfo || {};
          // console.log('[会员信息]', { userCategoryId, isNewMember });

          // 遍历所有装修数据
          props.decorateData.data.forEach((item, index) => {
            if (!isHotPicComponent(item)) {
              newVisibilityMap.set(index, false);
              return;
            }
            const visibility = calculateVisibility(item, userCategoryId, isNewMember);
            newVisibilityMap.set(index, visibility);
            
            // console.log(`[热区${index}] 可见状态: ${visibility}`, item.json_data.data);
          });

        } catch (error) {
          // console.error('[热区检查错误]', error);
        } finally {
          hotPicVisibility.value = newVisibilityMap;
          console.log('[热区可见性更新]', Array.from(newVisibilityMap.entries()));
        }
      };

      // 判断是否是热区切图组件
      const isHotPicComponent = (item) => {
        return item.json_data?.type === 'pic_hot';
      };

      // 计算单个热区切图的可见性
      const calculateVisibility = (item, userCategoryId, isNewMember) => {
        const { toufangSet, toufangSetSpe, toufangSetListData, toufangSetNew } = item.json_data.data;

        // 投放未开启：默认可见
        if (!toufangSet) {
          // console.log('[投放关闭] 默认所有人可见');
          return true;
        }

        // 投放策略判断
        switch (toufangSetSpe) {
          case 0: // 全部人群可见
            // console.log('[策略0] 全部人群可见');
            return true;

          case 1: { // 特定人群可见
            // 新会员优先判断
            if (toufangSetNew && isNewMember) {
              // console.log('[新会员] 满足新会员条件');
              return true;
            }

            // 检查指定会员类型
            const isSpecifiedMember = toufangSetListData?.some(member => 
              member.isSelected && member.id === userCategoryId
            );
            // console.log(`[指定会员] 检查结果: ${isSpecifiedMember}`, { userCategoryId });

            return isSpecifiedMember;
          }

          default:
            console.warn('[未知] 默认不可见');
            return false;
        }
      };

      // 获取会员信息（返回Promise）
      const getMemberInfo = () => {
        return proxy.$get('v3/member/front/member/memberInfo')
          .then(res => {
            if (res.state === 200) {
              return {
                userCategoryId: res.data.userCategoryId,
                isNewMember: res.data.isNewMember
              };
            }
            console.warn('[会员信息响应非200]', res.state);
            return null;
          })
          .catch(error => {
            console.error('[获取会员信息失败]', error);
            return null;
          });
      };
    return {
      L,
      goGoodsDetail,
      diyNavTo,
      adv19Tab,
      goGoodsListByCatId,
      dragEvent,
      hotPicDisplay,
      getMemberInfo,
      isViewInfoVisible,
      isShowHotPic,
      userCategoryId,
      isNewMember,
      isHotPicComponent,
      calculateVisibility,
      hotPicVisibility,
      bannerDisplay,
      isShowBanner,
      safeParseBannerData,
      isMainBanner,
      calculateBannerVisibility,
      bannerVisibility,
      bannerVisSet,
      loginFlag,
      winWidth,
      bannerDatasSet

    };
  },
};
</script>
<style lang="scss" scoped>
@import "../style/mixins.scss";
@import "../style/decorate.scss";

.sld_diy {
  background: #f8f8f8;
  position: relative;
  // overflow: scroll;

  .el-carousel {
    width: 100%;
    margin: 0 auto;
  }

  .el-carousel__item {
    /* width: 1920px;
            /*图片宽度*/
    /* position: absolute;
            left: 50%;
            margin-left: -960px; */
    /* 图片宽度的一半 */
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      background-position: center center;
      width: 1920px;
      height: 500px;
      position: absolute;
      left: 50%;
      top: 0;
      margin-left: -960px;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .main_banner {
    width: 100%;
    // height: 457px;
    height: 500px;
    position: relative;
    overflow: hidden;
    margin: 0 auto;

    .nav-menu {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      top: -3px;
      width: 187px;
      // height: 457px;
      height: 500px;
      z-index: 9;
      background-color: rgba(0, 0, 0, 0.6);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;

      .menu-wrap {
        .menu-item {
          height: 39px;
          line-height: 39px;
          margin: 5px 0;
          position: relative;

          .first_cat {
            width: 125px;
            display: block;
            font-size: 16px;
            color: #ffffff;
            padding-left: 30px;
            text-overflow: ellipsis;
            overflow: hidden;
            position: relative;

            .nav-menu {
              position: absolute;
              left: 50%;
              margin-left: -600px;
              top: -3px;
              width: 187px;
              height: 457px;
              z-index: 9;
              background-color: rgba(0, 0, 0, 0.6);
              -webkit-box-sizing: border-box;
              box-sizing: border-box;

              .menu-wrap {
                .menu-item {
                  height: 39px;
                  line-height: 39px;
                  margin: 5px 0;

                  .first_cat {
                    width: 125px;
                    display: block;
                    font-size: 16px;
                    color: #ffffff;
                    padding-left: 30px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    position: relative;

                    &:after {
                      position: absolute;
                      right: 0px;
                      top: 12.5px;
                      content: " ";
                      width: 7px !important;
                      height: 14px !important;
                      @include bgImg(7px, 14px, "/imgs/arrow_right.png");
                    }
                  }

                  &:hover {
                    background-color: var(--color_main);

                    .children {
                      display: inline-block;
                    }
                  }

                  .children {
                    display: none;
                    width: 1013px;
                    height: 417px;
                    background-color: #fff;
                    position: absolute;
                    top: 0;
                    left: 187px;
                    padding: 20px 0;

                    .fore-dl {
                      width: 100%;
                      clear: both;
                      overflow: hidden;
                    }

                    dt {
                      position: relative;
                      float: left;
                      width: 152px;
                      padding: 8px 30px 0 0;
                      text-align: right;
                      font-weight: 700;
                      line-height: 2em;
                      overflow: hidden;
                      white-space: nowrap;

                      i {
                        position: absolute;
                        top: 11px;
                        right: 18px;
                        width: 4px;
                        height: 14px;
                        font: 400 9px/14px consolas;
                      }

                      .second {
                        color: #333;
                        font-size: 14px;
                        width: 140px;
                        overflow: hidden;
                        display: inline-block;
                        line-height: 18px;
                        text-overflow: ellipsis;
                      }
                    }

                    dd {
                      border-top: none;
                      border-bottom: 1px dashed #dddddd;
                      width: 790px;
                      padding: 6px 0;
                      float: left;
                      line-height: 16px;
                      margin-left: 15px;
                    }

                    .third {
                      float: left;
                      padding: 0 8px;
                      margin: 4px 0;
                      line-height: 16px;
                      height: 16px;
                      border-right: 1px solid #e0e0e0;
                      white-space: nowrap;
                      color: #999;
                      font-size: 13px;
                    }

                    .children_item {
                      display: flex;
                      flex-direction: row;
                      justify-content: flex-start;
                      align-items: flex-start;
                      flex-wrap: wrap;
                      height: 30px;

                      .li_wrap {
                        height: 30px;
                        line-height: 30px;
                        flex: 1;
                        padding-left: 23px;

                        a {
                          line-height: 30px;
                          height: 30px;
                          color: #999999;
                        }
                      }

                      a {
                        color: var(--color_main);
                        font-size: 14px;
                      }

                      img {
                        width: 42px;
                        height: 35px;
                        vertical-align: middle;
                        margin-right: 15px;
                      }
                    }
                  }
                }
              }
            }
          }

          &:hover {
            background-color: var(--color_main);

            .children {
              display: inline-block;
            }
          }

          .children {
            display: none;
            width: 1013px;
            height: 417px;
            background-color: #fff;
            position: absolute;
            top: 0;
            left: 187px;
            padding: 20px 0;

            .fore-dl {
              width: 100%;
              clear: both;
              overflow: hidden;
            }

            dt {
              position: relative;
              float: left;
              width: 152px;
              padding: 8px 30px 0 0;
              text-align: right;
              font-weight: 700;
              line-height: 2em;
              overflow: hidden;
              white-space: nowrap;

              i {
                position: absolute;
                top: 11px;
                right: 18px;
                width: 4px;
                height: 14px;
                font: 400 9px/14px consolas;
              }

              .second {
                color: #333;
                font-size: 14px;
                width: 140px;
                overflow: hidden;
                display: inline-block;
                line-height: 18px;
                text-overflow: ellipsis;
              }
            }

            dd {
              border-top: none;
              border-bottom: 1px dashed #dddddd;
              width: 790px;
              padding: 6px 0;
              float: left;
              line-height: 16px;
              margin-left: 15px;
            }

            .third {
              float: left;
              padding: 0 8px;
              margin: 4px 0;
              line-height: 16px;
              height: 16px;
              border-right: 1px solid #e0e0e0;
              white-space: nowrap;
              color: #999;
              font-size: 13px;
            }

            .children_item {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: flex-start;
              flex-wrap: wrap;
              height: 30px;

              .li_wrap {
                height: 30px;
                line-height: 30px;
                flex: 1;
                padding-left: 23px;

                a {
                  line-height: 30px;
                  height: 30px;
                  color: #999999;
                }
              }

              a {
                color: var(--color_main);
                font-size: 14px;
              }

              img {
                width: 42px;
                height: 35px;
                vertical-align: middle;
                margin-right: 15px;
              }
            }
          }
        }
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      position: absolute;

      .swiper-slide {
        a {
          display: inline-block;
          width: 100%;
          height: 100%;

          img {
            width: 1920px;
            height: 100%;
            margin-left: -960px;
            left: 50%;
            position: relative;
            overflow: hidden;
          }
        }
      }
    }
  }

  .main_diy {
    margin-top: 10px;
  }

  .product-box {
    background-color: $colorJ;
    padding: 30px 0 50px;

    h2 {
      font-size: $fontF;
      height: 21px;
      line-height: 21px;
      color: var(--color_main);
      margin-bottom: 20px;
    }

    .wrapper {
      display: flex;

      .banner-left {
        margin-right: 16px;

        img {
          width: 224px;
          height: 619px;
        }
      }

      .list-box {
        .list {
          @include flex();
          width: 986px;
          margin-bottom: 14px;

          &:last-child {
            margin-bottom: 0;
          }

          .item {
            width: 236px;
            height: 302px;
            background-color: $colorG;
            text-align: center;

            span {
              display: inline-block;
              width: 67px;
              height: 24px;
              font-size: 14px;
              line-height: 24px;
              color: $colorG;

              &.new-pro {
                background-color: #7ecf68;
              }

              &.kill-pro {
                background-color: #e82626;
              }
            }

            .item-img {
              img {
                width: 100%;
                height: 195px;
              }
            }

            .item-info {
              h3 {
                font-size: 14px;
                color: var(--color_main);
                line-height: 14px;
                font-weight: bold;
              }

              p {
                color: $colorD;
                line-height: 13px;
                margin: 6px auto 13px;
              }

              .price {
                color: #f20a0a;
                font-size: 14px;
                font-weight: bold;
                cursor: pointer;

                &:after {
                  @include bgImg(22px, 22px, "/imgs/icon-cart-hover.png");
                  content: " ";
                  margin-left: 5px;
                  vertical-align: middle;
                }
              }
            }
          }
        }
      }
    }
  }
}

.hot_wrap {
  position: relative;
  display: flex;
  justify-content: center;
  //background-size: contain;
  background-repeat: no-repeat;

  .hot_area_div {
    position: absolute;
  }
}

.adv_title_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 1336px;
  // background: rgba(217, 217, 217, 0);
  margin: auto;
  // margin-bottom: 10px;

  .adv_title_center {
    width: calc(100% / 3);
    height: 100%;
  }

  .adv_title {
    font-family: Microsoft YaHei,Microsoft YaHei ;
    font-weight: 500;
    font-size: 25px;
    // color: #000000;
  }

  .view_info {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    span {
      font-family: Microsoft YaHei,Microsoft YaHei ;
      font-weight: 400;
      font-size: 15px;
      color: #000000;
      line-height: 22px;
    }

    img {
      width: 20px;
      height: 20px;
      // margin-left: 5px;
      margin: auto 0px auto 5px;
    }
  }
}

::v-deep .el-carousel__arrow--left {
  left: 114px !important;
  width: 54px !important;
  height: 54px !important;
  background-color: rgba(52, 54, 59, 0.3) !important;
}
::v-deep .el-carousel__arrow--left:hover {
  left: 114px !important;
  width: 54px !important;
  height: 54px !important;
  background-color: rgba(52, 54, 59, 0.5) !important;
}
::v-deep .el-carousel__arrow--right {
  right: 114px !important;
  width: 54px !important;
  height: 54px !important;
  background-color: rgba(52, 54, 59, 0.3) !important;
}
::v-deep .el-carousel__arrow--right:hover {
  right: 114px !important;
  width: 54px !important;
  height: 54px !important;
  background-color: rgba(52, 54, 59, 0.5) !important;
}
::v-deep .el-carousel__arrow i {
  cursor: pointer 227px !important;
  width: 40px 227px !important;
  height: 40px 227px !important;
}

// ::v-deep .el-icon-arrow-left:before {
//   // content: "";
//   font-size: 40px !important;
//   color: #ffffff !important;
// }

::v-deep .el-icon-arrow-left:before {
  content: ""; /* 必须设置 content，否则伪元素不生效 */
  background-image: url('../assets/left_arrow.png');
  background-size: cover; /* 让图片覆盖整个区域 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 58px;
  height: 58px;
  display: inline-table;
  left: -2px;
  position: absolute;
  top: -2px;
}

::v-deep .el-icon-arrow-right:before {
  content: ""; /* 必须设置 content，否则伪元素不生效 */
  background-image: url('../assets/right_arrow.png');
  background-size: cover; /* 让图片覆盖整个区域 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 58px;
  height: 58px;
  display: inline-table;
  left: -2px;
  position: absolute;
  top: -2px;
}

// ::v-deep .el-icon-arrow-right:before {
//   // content: "";
//   font-size: 40px !important;
//   color: #ffffff !important;
// }

.ellipsis {
  white-space: nowrap; /* 防止文字换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分用省略号表示 */
  width: 100%; /* 必须指定宽度或者max-width */
  // display: inline-block; /* 让元素能够根据内容调整大小，同时保持宽度限制 */
  max-width: 215px; /* 根据实际需要调整宽度 */
}
.ellipsis_pp{
  white-space: nowrap; /* 防止文字换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分用省略号表示 */
  width: 100%; /* 必须指定宽度或者max-width */
  // display: inline-block; /* 让元素能够根据内容调整大小，同时保持宽度限制 */
  max-width: 180px; /* 根据实际需要调整宽度 */
}

</style>